import { createAction } from 'redux-actions';

import { UPDATE_THEME_MARKUP } from 'app/styles/constants/actionTypes';

const updateThemeMarkup = createAction(UPDATE_THEME_MARKUP);

export { updateThemeMarkup };
